import { CloudUpload } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import { Box, Tooltip, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import { useDispatch } from "react-redux";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export const blobUrlToFile = async (blobUrl, filename = "image") => {
  try {
    const response = await fetch(blobUrl);
    const blob = await response.blob();
    return new File([blob], `${filename}.${blob.type.split("/")[1]}`, {
      type: blob.type,
    });
  } catch (error) {
    console.error("Error al convertir URL de Blob a File:", error);
    return null;
  }
};

export default function IconButtonFileUpload({ updateComponentState, setChanges = () => {} }) {
  const [uploadStatus, setUploadStatus] = useState("");
  const [uploading, setUploading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const dispatch = useDispatch();

  const handleFileChange = async (event) => {
    const file = event.target.files[0];

    if (file) {
      const maxSize = 2 * 1024 * 1024; // 2MB en bytes
      if (file.size > maxSize) {
        setErrorMessage("Image must be under 2MB. Please select another one.");
        return;
      } else {
        setErrorMessage("");
      }

      setChanges(true);
      const previewUrl = URL.createObjectURL(file);
      console.log("the imageUrl: ", previewUrl);
      console.log("the file: ", file);
      dispatch(updateComponentState({ imageUrl: previewUrl }));
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Tooltip title="Please upload an image smaller than 2MB." arrow>
        <label htmlFor="icon-button-file">
          <IconButton color="primary" aria-label="upload picture" component="span" disabled={uploading}>
            {uploading ? <CircularProgress /> : <CloudUpload />}
          </IconButton>
          <VisuallyHiddenInput accept="image/*" id="icon-button-file" type="file" onChange={handleFileChange} />
        </label>
      </Tooltip>

      {errorMessage && (
        <Typography
          sx={{
            fontSize: "0.9em",
            color: "red",
          }}
        >
          {errorMessage}
        </Typography>
      )}

      <Typography
        sx={{
          fontSize: {
            xs: "0.8em",
            md: "1em",
          },
        }}
        variant="h3"
        color="initial"
      >
        {uploadStatus}
      </Typography>
    </Box>
  );
}
